import { runSchedule } from '@/redux/requests/schedulesRequests.js';
import { dispatchTrigger } from '@/redux/requests/triggersRequests.js';
import { runWorkflow } from '@/redux/requests/workflowsRequests.js';

/**
 * Starts one run of an automation now, outside its schedule: a schedule runs its instructions, a trigger
 * checks its app for new events, a workflow runs its published steps. Resolves to the request's result.
 */
const runAutomationNow = ({ kind, id }) => {
  if (kind === 'schedules') {
    return runSchedule({ scheduleId: id });
  }

  if (kind === 'triggers') {
    return dispatchTrigger({ triggerId: id });
  }

  return runWorkflow({ workflowId: id });
};

export default runAutomationNow;
